import LastManagerInfo from '../../panels/user/editPanel/LastManagerInfo'
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog'
import $ from '../../alias/jquery'
import UserDataLightBox from './UserDataLightBox'
import messageResource from '../../messageResource'
import {Product} from '../../constants'

export default function EditUserLightBox()
{
}

EditUserLightBox.prototype = new UserDataLightBox();

EditUserLightBox.prototype.close_tab_confirmation_message_key = "user.edit.js.close_tab_confirmation";

EditUserLightBox.prototype.init = function( sectionsBuilder, userManagementData, userAccountSettings, user, hasTimeTrack,
                                            isLastAdminInAT, isLastAdminInAP, lastLicensesManager, otherProductStatusEditable, lastLoginTime, handlerIfNoSuchUserAfterAjax)
{
    this.handlerIfNoSuchUserAfterAjax = function(userId){
        self.hide();
        if(handlerIfNoSuchUserAfterAjax)
        {
            handlerIfNoSuchUserAfterAjax( userId );
        }
    };


    UserDataLightBox.prototype.init.call(this, sectionsBuilder, userManagementData, user.id, userAccountSettings, true, otherProductStatusEditable);

    var self = this;

    this.deleteButton = document.getElementById( this.lightBoxEl.id + "_deleteBtn" );
    this.lastLoginInfoPlaceholder = document.getElementById( this.lightBoxEl.id + "_lastLoginInfoPlaceholder" );
    this.deleteButton.onclick = function() { self.deleteUser() };
    this.deleteCallback = null;
    this.dateFormat = SystemSettings.dateFormat;
    this.clockFormat = SystemSettings.clockFormat;

    this.setTitle("");
    this.setNameInTitle(
        this.formatUserName(
            user.firstName,
            user.lastName,
            user.middleInitial )
    );

    if(isOlVersion)
    {
        this.setLastLoginInfoInTitle( lastLoginTime != null ?
                                      lastLoginTime :
                                      messageResource.getMessage( "user.edit.js.never_logged_in" ) );
    }


    this.setCommitButtonTitle(messageResource.getMessage("user.edit.js.save_changes"));

    this.validateAll( false );

    this.setDeleteButtonVisibility( true );
    this.updateDeleteButton(hasTimeTrack, isLastAdminInAT, isLastAdminInAP);

    this.cancel_confirmation_message_key = "user.edit.js.cancel_confirmation";

    $(this.lightBoxEl).addClass("editMode");

    this.user = user
    this.lastLicensesManager = lastLicensesManager
    this.accountInformation = this._orderedSectionsList[0]

    return this;
};

EditUserLightBox.prototype.setLastLoginInfoInTitle = function(text) {
    this.lastLoginInfoPlaceholder.innerHTML = '(' + messageResource.getMessage("user.edit.js.last_login") +  ' ' + text + ')';
};

EditUserLightBox.prototype.changesDetected = function()
{
    this.getFooterEl().className = this.footerClassName + ' changesDetected';
};

EditUserLightBox.prototype.updateDeleteButton = function(hasTimeTrack, isLastAdminInAT, isLastAdminInAP)
{
    if (hasTimeTrack) {
        this.setDeleteButtonEnabled(false, messageResource.getMessage("user.edit.js.cannot_delete.has_task_record"));
    } else if (isLastAdminInAT) {
        this.setDeleteButtonEnabled(false, messageResource.getMessage("user.edit.js.cannot_delete.last_admin_at"));
    } else if (isLastAdminInAP) {
        this.setDeleteButtonEnabled(false, messageResource.getMessage("user.edit.js.cannot_delete.last_admin_ap"));
    } else {
        this.setDeleteButtonEnabled(true);
    }
};

EditUserLightBox.prototype.deleteUser = function()
{
    if (this.deleteCallback && confirm(messageResource.getMessage('userlist.js.confirm_delete_user'))) {
        this.lastLicensesManager
        ? this.deleteAlert.show()
        : this.deleteCallback(this.userId)
    }
};

EditUserLightBox.prototype.setDeleteButtonEnabled = function(enabled, tooltip)
{
    this.deleteButton.disabled = !enabled;
    if (tooltip) {
        this.deleteButton.title = tooltip;
    } else {
        this.deleteButton.removeAttribute("title");
    }
};

EditUserLightBox.prototype.setDeleteCallback = function( deleteCallback )
{
    this.deleteCallback = deleteCallback;
};

EditUserLightBox.prototype.show = function() {
    UserDataLightBox.prototype.show.call( this );
    this._sectionsBuilder.initAfterShowing( false );
};



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/EditUserLightBox.js